import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { SubscribersService } from '@coreservices';
import { Router } from '@angular/router';

/**
 * The header's notification drawer — the shell (heading, unread count, close,
 * "View all") around `<app-notification-feed>`, which owns the list, its tabs
 * and filters, the row actions and the paging.
 */
@Component({
  standalone: false,
  selector: 'app-notification-sidebar',
  templateUrl: './notification-sidebar.component.html',
  styleUrls: ['./notification-sidebar.component.css']
})
export class NotificationSidebarComponent implements OnInit {
  private sidebarSubscription: Subscription;
  toggleStyle: boolean = false;
  /** The reader's unread total, from the feed's server count — not the rows loaded. */
  unreadCount = 0;
  /** Emitted when the drawer closes itself (× / scrim / navigation) so the host
   *  header can unmount it. Owning the flag in the header keeps open/close
   *  reliable across repeated toggles. */
  @Output() closed = new EventEmitter<void>();

  constructor(
    private router: Router,
    private changeDetection: ChangeDetectorRef,
    private subscribersService: SubscribersService,
  ) {
    this.sidebarSubscription = this.subscribersService.notificationSidebar.subscribe((options) => {
      this.toggleStyle = options;
    });
  }

  /************************************
  * Life cycle hooks start
  ************************************/

  ngOnInit(): void {
    // The panel is only mounted while it should be open, so flip the slide on
    // just after the first paint — this animates it in reliably regardless of
    // the header's toggle Subject (a plain Subject that a fresh mount can miss).
    setTimeout(() => {
      this.toggleStyle = true;
      this.changeDetection.detectChanges();
    }, 20);
  }

  ngOnDestroy(): void {
    this.sidebarSubscription.unsubscribe();
  }

  /************************************
  * Life cycle hooks end
  ************************************/

  /************************************
  * Sidebar management start
  ************************************/

  closeAddItemSidebar(event?: Event) {
    if (event) {
      event.preventDefault();
    }
    // Slide out, then tell the host header to unmount. The timer is tied to
    // THIS instance's (closed) output — if the drawer is torn down first (e.g.
    // the bell toggled it off), the emit simply has no listener, so a stale
    // timer can never close a freshly reopened drawer (the old reopen bug).
    this.toggleStyle = false;
    this.subscribersService.notificationSidebarToggle(false);
    setTimeout(() => this.closed.emit(), 250);
  }

  onUnreadTotal(total: number): void {
    this.unreadCount = total;
    this.changeDetection.detectChanges();
  }

  seeAllNotifications() {
    this.router.navigate(['notifications']);
    this.closeAddItemSidebar();
  }

  /************************************
  * Sidebar management end
  ************************************/
}
